import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "app/app.config";
import { BaseService } from "./baseService";
import { AppInsightService } from "./app-insight.service";

@Injectable()
export class RecommendationTrackerService extends BaseService{
    private controllerName:string = '/case/recommendationReport';

    constructor(protected http: HttpClient, protected config: AppConfig, protected appInsights: AppInsightService) {
        super(http, config, appInsights);
    }

    public getRecommendationTrackerReport(quarter: number, year: number, jurisdiction: string): Promise<RecommendationTrackerReport> {
        let params = {
            quarter : quarter,
            year : year,
            jurisdiction : jurisdiction
        };
        return this.httpget<RecommendationTrackerReport>(`${this.controllerName}`, params);
    }

    public getRecommendationsSectionSubsection(section: string, subsection: string, quarter: number, year: number, jurisdiction: string): Promise<Array<Recommendation>> {
        let params = {
            section: section,
            subsection: subsection,
            quarter : quarter,
            year : year,
            jurisdiction : jurisdiction
        }
        var url = `/recommendation/bysectionsubsection`;
        return this.httpget<Array<Recommendation>>(url, params);
    }

    public AddRecommendation(newRecommendation : Recommendation): Promise<any> {
        var url = `/recommendation`;
        
        return this.httppost<any>(url, newRecommendation);
    }

    public getRecommendationTrackerCases(jurisdiction: string, quarter: number, year: number, subsection: string, section: string) : Promise<Array<RecommendationTrackerCase>> {
        let params = {
            jurisdiction: jurisdiction,
            quarter: quarter,
            year: year,
            subsection: subsection,
            section: section
        }

        var url = '/case/recommendationCases';

        return this.httpget<Array<RecommendationTrackerCase>>(url, params);
    }
}

export class RecommendationTrackerReport {
    public RecommendationTrackerDataGroups : Array<RecommendationTrackerDataGroup>;
    public Jurisdiction : string;
    public Quarter : string;
    public Year : string;
}

export class RecommendationTrackerDataGroup {
    public Name : string;
    public RecommendationTrackerData : Array<RecommendationTrackerData>;
}

export class RecommendationTrackerData {
    public Field : string;
    public QuarterTotals : number;
    public YearToDateTotals : number;
}

export class Recommendation {
    public Jurisdiction : string;
    public Quarter : number;
    public Year : number;
    public Username : string;
    public PostedOn : string;
    public Content : string;
    public Section : string;
    public SubSection : string;
}

export class RecommendationTrackerCase {
    public id : string;
    public OCME : string;
}